export default {
  path: 'patrol-vehicle-service/work-orders',
  name: 'PatrolVehicleService',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/PatrolVehicleServiceWorkOrdersIndex.vue')
}
